import React, { useState } from 'react';
import { ActivityEntry, ActivityFilter } from '../../types/activity';
import { ActivityItem } from './ActivityItem';
import { Filter, MessageSquare } from 'lucide-react';

interface ActivityTimelineProps {
  entries: ActivityEntry[];
  currentUserRole?: string;
}

export const ActivityTimeline: React.FC<ActivityTimelineProps> = ({ entries, currentUserRole }) => {
  const [filterType, setFilterType] = useState<ActivityFilter['activity_type'] | 'all'>('all');

  const isOfficerOrSupervisor = currentUserRole === 'OFFICER' || currentUserRole === 'SUPERVISOR' || currentUserRole === 'ADMIN';

  const filtered = entries.filter(entry => {
    if (entry.is_internal && !isOfficerOrSupervisor) return false;
    if (filterType !== 'all' && entry.activity_type !== filterType) return false;
    return true;
  }).sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 flex-wrap">
        <Filter className="w-3.5 h-3.5 text-slate-500" />
        {(['all', 'comment', 'status_change', 'assignment', 'internal_note'] as const).map(type => (
          <button
            key={type}
            onClick={() => setFilterType(type)}
            className={`px-2.5 py-1 rounded-lg text-[10px] font-medium transition-colors ${
              filterType === type
                ? 'bg-sky-600 text-white'
                : 'bg-slate-800 text-slate-400 hover:bg-slate-700'
            }`}
          >
            {type === 'all' ? 'All' : type === 'status_change' ? 'Status' : type === 'internal_note' ? 'Internal' : type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-6">
          <MessageSquare className="w-8 h-8 text-slate-600 mx-auto mb-2" />
          <p className="text-xs text-slate-500">No activity entries yet</p>
        </div>
      ) : (
        <div className="divide-y divide-slate-800/60">
          {filtered.map(entry => (
            <ActivityItem key={entry.id} entry={entry} />
          ))}
        </div>
      )}
    </div>
  );
};
